import * as emService from '../../services/em.service';

const state = {
    eMWizardStep:1,
    eMDocumentPaginate:{},
    eMDocumentPaginateData:{},
    eMWizardData:{
      selected:[],
      selectedAll:'',
      docId:0,
      subject:'',
      content:'',
      runMode:'',
      employerPaginate:{}
    }
};

const getters = {
    getEMWizardStep:state => (state.eMWizardStep),
    getEMDocumentPaginate:state => (state.eMDocumentPaginate),
    getEMDocumentPaginateData:state => (state.eMDocumentPaginateData),
    getEMWizardData:state => (state.eMWizardData),
};

const actions = {
    fetchEMWizardStep({ commit }, step){
        commit('setEMWizardStep', step)
    },

    async fetchEMDocumentPaginate({ commit }, obj){
      commit('setEMDocumentPaginate', obj)
      try {
          const response = await emService.listPageDocument(obj);
          commit('setEMDocumentPaginateData', response.data);
      } catch (error) {
          console.log('something wrong - fetchEMDocumentPaginate', error);
      }
    },

  /**
   * Post Wizard data
   * @param {*} Obj
   */
    async fetchEMWizardData({ commit }, Obj){
      try {
          commit('setEMWizardData', Obj);
      } catch (error) {
          console.log('something wrong - fetchEMWizardData', error);
      }
    },
};

const mutations = {
  setEMWizardStep:(state, res) => (
      state.eMWizardStep =  res
  ),
  setEMDocumentPaginateData:(state, res) => (
    state.eMDocumentPaginateData =  res
  ),
  setEMDocumentPaginate:(state, res) => (
      state.eMDocumentPaginate =  res
  ),
  setEMWizardData:(state, res) => (
    state.eMWizardData =  res
  ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}
